// extracted by mini-css-extract-plugin
module.exports = {"pay":"DataScience_pay__CJhBp","datascitab":"DataScience_datascitab__gcdO6"};